/* eslint-disable */
// @ts-nocheck

/**
 * Transform Pinecone job matches from Silver Agent API to the format expected by JobPoolItemAi component
 */
export interface PineconeJobMatch {
    id: string;
    score: number;
    metadata: {
        city?: string;
        created_date?: string;
        description: string;
        keyword?: string;
        link: string;
        location: string;
        title: string;
        lat_max?: number;
        lat_min?: number;
        lon_max?: number;
        lon_min?: number;
    };
    query_text?: string;
    distance_km?: number;
    index?: number;
}

export interface TransformedAiJob {
    id: string;
    title: string;
    location: string;
    link: string;
    description: string;
    fullDescription: string;
    matchScore: number;
}

export interface SilverAgentJobsResponse {
    matches: PineconeJobMatch[];
}

/**
 * Transform a single Pinecone job match to AiJob format
 */
export const transformPineconeJobMatch = (job: PineconeJobMatch): TransformedAiJob => {
    const fullDescription = job.metadata?.description || '';

    // Truncate description for display (max 300 chars)
    const description = fullDescription.length > 300
        ? fullDescription.substring(0, 300) + '...'
        : fullDescription;

    return {
        id: job.id,
        title: job.metadata?.title || 'Job Position',
        location: job.metadata?.location || job.metadata?.city || 'Location',
        link: job.metadata?.link || '#',
        description, // Truncated for UI display
        fullDescription, // Full description for cover letter generation
        matchScore: job.score ? Math.round(job.score * 100) : 0
    };
};

/**
 * Transform the entire Silver Agent jobs response
 */
export const transformSilverAgentJobs = (response: SilverAgentJobsResponse): TransformedAiJob[] => {
    if (!response?.matches || !Array.isArray(response.matches)) {
        console.warn('Invalid Silver Agent jobs response:', response);
        return [];
    }

    return response.matches.map(transformPineconeJobMatch);
};